module.exports = __webpack_public_path__ + "img/partnership_05.9350afa0.jpg";